{
  "verified": "Ověřeno",
  "iv_status": {
    "verified": "Ověřeno",
    "pending": "Čeká se na",
    "attention": "Pozor"
  },
  "zoom_in": "Přiblížení",
  "zoom_out": "Zvětšení",
  "rotate": "Rotace",
  "close": "Zavřít",
  "esc_to_close": "Stisknutím ESC zavřete",
  "play": "Přehrát",
  "pause": "Pauza",
  "mute": "Ztlumit",
  "unmute": "Zrušit ztlumení",
  "enter_full_screen": "Vstup na celou obrazovku",
  "exit_full_screen": "Ukončení celé obrazovky",
  "video_not_supported": "Váš prohlížeč nepodporuje značku videa.",
  "skip_forward": "Přeskočit dopředu",
  "skip_backward": "Přeskočit zpět",
  "loading": "Načítání",
  "loading_video": "Načítání videa...",
  "loading_data_description": "Počkejte prosím, než načteme vaše data. Nebude to trvat dlouho.",
  "no_results": "Žádné výsledky",
  "nothing_found": "Nic nebylo nalezeno",
  "save_changes": "Uložení změn",
  "saved_exclamation": "Zachráněno!",
  "saving": "Úspora",
  "validating": "Ověřování",
  "error": "Chyba",
  "optional": "Volitelně",
  "search_property": "Vyhledávání nemovitostí",
  "reset_search": "Obnovení vyhledávání",
  "no_items_to_show": "Žádné položky k zobrazení",
  "showing_range_of_total_items": "Zobrazeno {{range}} z {{total}} položek",
  "rows_per_page": "Řádky na stránku",
  "page_of_pages": "Strana {{page}} z {{pages}}",
  "go_to_first_page": "Přejít na první stránku",
  "go_to_previous_page": "Přejít na předchozí stránku",
  "go_to_next_page": "Přejít na další stránku",
  "go_to_last_page": "Přejít na poslední stránku",
  "sort_in_asc": "Seřadit vzestupně",
  "sort_in_desc": "Seřadit sestupně",
  "sort_a_z": "Třídit A → Z",
  "sort_z_a": "Třídit Z → A",
  "clear_sorting": "Přehledné třídění",
  "reach_us_at_email": "Získejte podporu na adrese support@chekin.com",
  "please_wait": "Počkejte prosím",
  "feature_coming_soon": "Již brzy",
  "feature_coming_soon_description": "Tato funkce je v současné době ve vývoji a bude brzy k dispozici. Zůstaňte naladěni na aktualizace!",
  "download_all": "Stáhnout vše",
  "entry_forms": "Přihlašovací formuláře",
  "tutorial": "Výukový program",
  "liveness_video": "Video Liveness",
  "beta": "Beta",
  "reviews": "Recenze",
  "learn_more": "Zjistěte více",
  "this_cannot_be_reverted": "To nelze vrátit zpět",
  "delete": "Odstranit",
  "cancel": "Zrušit",
  "you_have_made_changes": "Provedli jste změny",
  "would_you_like_to_save_them": "Chcete je zachránit?",
  "save": "Uložit",
  "dont_save": "Neukládejte",
  "copied_exclamation": "Zkopírováno!",
  "search_placeholder": "Vyhledávání...",
  "type_to_search": "Zadejte hledání...",
  "loading_more": "Načítání...",
  "no_options": "Žádné možnosti",
  "select_option": "Vyberte možnost",
  "clear_all": "Vymazat vše",
  "remove_item": "Odstranění {{label}}",
  "upload_file": "Nahrát soubor",
  "download_attachment": "Stáhnout přílohu",
  "remove_file": "Odstranění souboru",
  "open_calendar": "Otevřený kalendář",
  "clear_dates": "Jasná data",
  "select_dates": "Zvolte data",
  "pick_date_range": "Výběr rozsahu dat",
  "from": "Z",
  "to": "Na",
  "pick_month": "Vyberte si měsíc",
  "pick_date": "Výběr data",
  "month": "Měsíc",
  "day": "Den",
  "year": "Rok",
  "done": "Hotovo",
  "wrong_period_of_dates": "Zvolené období je neplatné",
  "date_range_max_days_error_one": "Rozsah nesmí překročit {{count}} den",
  "date_range_max_days_error_other": "Rozsah nesmí překročit {{count}} dnů",
  "date_range_min_days_error_one": "Rozsah musí být alespoň {{count}} den",
  "date_range_min_days_error_other": "Rozsah musí být alespoň {{count}} dní",
  "past_dates": "Datum nesmí být starší než {{minDate}}",
  "future_dates": "Datum nesmí být po {{maxDate}}",
  "signature_placeholder_text": "Podepište se do tohoto pole.<br/> Použijte prst.<br/> Klepnutím na začněte.",
  "open_devices_camera": "Otevření fotoaparátu zařízení",
  "place_document_inside_frame": "Umístěte dokument do rámečku",
  "close_other_application_that_may_be_using_your_camera": "Zavření dalších aplikací, které mohou používat fotoaparát",
  "if_you_use_external_camera_disconnect_and_reconnect": "Pokud používáte externí kameru, odpojte ji a znovu připojte.",
  "close_the_browser_re_open_it": "Zavřete prohlížeč a znovu jej otevřete",
  "camera_errors": {
    "experiencing_camera_issues": "Máte problémy s fotoaparátem?",
    "chekin_cant_use_your_camera": "Chekin nemůže používat váš fotoaparát",
    "please_try_a_different_browser": "Váš fotoaparát v tomto prohlížeči nefunguje. Zkuste prosím otevřít odkaz v jiném prohlížeči.",
    "permissions_denied": "Povolení zamítnuto",
    "camera_permissions_denied": "Fotoaparát se neotevře? Ujistěte se, že jste prohlížeči povolili používat kameru.",
    "no_camera_device_found": "Nebylo nalezeno žádné zařízení fotoaparátu. Připojte fotoaparát.",
    "constraints_camera_error": "Omezení nelze splnit dostupnými zařízeními.",
    "safari_camera_error": "Safari nemohlo splnit požadavky na fotoaparát",
    "try_chrome_or_firefox": "Zkuste prosím Chrome nebo Firefox"
  },
  "clear": "Přehledně",
  "show_less": "Zobrazit méně",
  "show_more": "Zobrazit více",
  "tap_here_to_sign": "Klepnutím zde podepíšete",
  "click_here_to_sign": "Klikněte zde a podepište se",
  "prefix": "Předpona",
  "prefix_required": "Předpona je povinná",
  "reset": "Obnovení",
  "show_password": "Zobrazit heslo",
  "hide_password": "Skrýt heslo",
  "increment": "Přírůstek",
  "decrement": "Snížení",
  "create_option": "Vytvořit \"{{input}}\"",
  "year_out_of_range": "Rok musí být mezi {{min}} a {{max}}.",
  "clear_date": "Datum vymazání",
  "select_date": "Zvolte datum",
  "draw_signature_here": "Zde se podepište",
  "signature_hint": "Použijte myš nebo prst",
  "clear_signature": "Čitelný podpis",
  "draw_signature_here_mobile": "Nakreslete svůj podpis",
  "signature_hint_mobile": "Použijte prst",
  "camera_access_needed": "Je nutný přístup k fotoaparátu",
  "camera_access_needed_text": "Povolte fotoaparátu přístup, aby bylo možné pořídit fotografii. Pokud je přístup blokován, povolte fotoaparát v nastavení prohlížeče a zkuste to znovu.",
  "dialog": "Dialog"
}
